import { Grid, Typography } from '@mui/material'
import React from 'react'
import FileUpload from '../../utility/fileUpload/fileUpload';
import GlobalButton from '../../utility/globalButton/button';
import style from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../assets/styles/global.module.scss";
import { progressInterface } from './createNewContactPopup';
import DownloadIcon from '@mui/icons-material/Download';
import { whiteColor } from '../../../utils/colors';

interface ContactCardTemplateProps {
    onClickOfImportButton: () => void,
    files: any,
    setFiles: React.Dispatch<React.SetStateAction<any>>,
    setFieldsOfCSV: React.Dispatch<React.SetStateAction<string[]>>,
    jsonArray: null | any[],
    setJsonArray: React.Dispatch<React.SetStateAction<null | any[]>>,
    downloadSampleCSVTemplate: () => void,
}

const ContactCardTemplate: React.FC<ContactCardTemplateProps> = ({ onClickOfImportButton, files, setFiles, setFieldsOfCSV, jsonArray, setJsonArray, downloadSampleCSVTemplate }) => {

    const uploadFile = (event: any) => {
        const file = event.target.files[0];
        if (!file) return;
        
        setFiles([file]);
        const reader = new FileReader();

        reader.onload = (e) => {
            const text = e.target?.result;
            if (typeof text === "string") {
                const json = csvToJson(text);
                if(json.length > 0){
                    setFieldsOfCSV(Object.keys(json[0]));
                }
                setJsonArray(json);
            } else {
                console.error("File content is not a string.");
            }
        };

        reader.readAsText(file);
    }

    function csvToJson(csvString: string) {
        const [headerLine, ...lines] = csvString.trim().split("\n");
        const headers = headerLine.split(",");

        return lines.map(line => {
            const values = line.split(",");
            return headers.reduce((obj: any, header, i) => {
                obj[header.trim()] = values[i]?.trim();
                return obj;
            }, {});
        });
    }

    const removeFile = () => {
        setFiles([]);
        setFieldsOfCSV([]);
        setJsonArray(null);
    }

    return (
        <>
            <Grid container direction={"column"} gap={"12px"} className={style.importContactViaCSVGrid}>
                <Grid item xs={12}>
                    <Grid container justifyContent="space-between" gap={"11px"} alignItems="center">
                        <Grid item>
                            <Typography className={style.importCSVTitle}>Import Contact (Upload CSV File)</Typography>
                            <Typography className={style.importCSVLimit}>Maximum contact upload limit <span className={`${globalStyles.tertiaryFontSize} ${globalStyles.blackColor}`}>10,000</span> contacts</Typography>
                            <Typography className={style.importCSVLimit}>Phone number, country code and first name are mandatory fields. Contacts missing either of these will not be imported.</Typography>
                        </Grid>
                        <Grid item>
                            <Grid container alignItems="center" gap={"5px"} onClick={() => downloadSampleCSVTemplate()} className={globalStyles.clickable}>
                                <DownloadIcon className={`${style.downloadCSVTemplateIcon}`} />
                                <Typography className={style.downloadCSVTemplateText}>
                                    Download Sample CSV
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} className={globalStyles.fullwidth}>
                    <FileUpload
                        uploadedFileDetails={files}
                        multipleFileAllow={true}
                        fileSizeAllowed={3}
                        fileTypeAllowed={'.csv, application/csv'}
                        fileNumberAllowed={1}
                        isDisabled={false}
                        uploadFileHandler={uploadFile} 
                        removeFileHandler={removeFile}
                        bgColor={whiteColor}
                    />
                </Grid>

                <Grid item xs={12}>
                    <Grid container justifyContent={"space-between"} alignItems={"start"}>
                        <Grid item>
                            <GlobalButton
                                buttonText={"Continue"}
                                className='primaryButtonStyle'
                                sx={{ width: "130px" }}
                                // disabled={files.length === 0} 
                                disabled={!jsonArray || jsonArray.length == 0}
                                onClick={(e) => { onClickOfImportButton() }}
                            />
                        </Grid>
                        {jsonArray && 
                            <>
                                {jsonArray.length == 0 ?
                                        <Grid item>
                                            <Typography className={style.noContactsFoundTypography}>No Contacts Found!</Typography>
                                        </Grid>
                                    : 
                                         <Grid item>
                                            <Typography className={style.contactsTitleTypography}>{jsonArray.length} Contacts</Typography>
                                        </Grid>
                                }
                            </>
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ContactCardTemplate
